import React, {useState, useEffect, useRef, memo, useCallback} from 'react';
import {SVGICONS} from '@ey/icons';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {getAnnotationById} from '../../../selectors/Ares/annotations';
import Utility from '../../../util/utilityfunctions';
import {labels} from '../../../util/utils';
import {isEqual} from 'lodash';

function InlineAnnotation(params) {
	const {showButtons, isDisabled} = params;
	const {id: annotationId, financialStatementId} = params.data;

	const annotation = useSelector(getAnnotationById(annotationId));
	const [showIcon, setShowIcon] = useState(false);

	const myRef = useRef();

	const editAnnotation = useCallback(() => {

		params.openModal(true, financialStatementId);
	}, [financialStatementId, params]);

	return (
		<StyledInlineAnnotation
			ref={myRef}
			className="StyledInlineAnnotation"
			onMouseEnter={() => {
				setShowIcon(true);
			}}
			onMouseLeave={() => {
				setShowIcon(false);
			}}
		>
			<span className="AnnotationLabelText">{labels.OARAnnotation + ': '}</span>
			{Utility.createRichTextElement(annotation.annotationText, 'annotation-text ql-editor')}
			{showButtons && showIcon && !isDisabled && (
				<span className="editIcon" onClick={editAnnotation}>
					<SVGICONS styleName="medium" name="edit" hoverText={labels.edit} />
					<span className="LabelText">{labels.edit}</span>
				</span>
			)}
		</StyledInlineAnnotation>
	);
}

export default memo(InlineAnnotation, isEqual);

const StyledInlineAnnotation = styled.section`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
	padding: var(--px-6) var(--px-30) var(--px-16) 0 !important;
	position: relative;
	.AnnotationLabelText {
		font-size: var(--px-12);
		line-height: var(--px-24);
		color: var(--neutrals-900);
	}
	.annotation-text {
		width: 100%;
		/* * {
			font-size: var(--px-12);
			line-height: var(--px-24);
			width: 100%;
			height: 100%;
			color: var(--neutrals-900);
		} */
		u > * {
			text-decoration: underline;
		}
		a,
		a * {
			color: var(--blue-600);
		}
		p {
			white-space: normal;
		}
		ol,
		ul {
			margin: 0 !important;
			padding: 0 0 0 var(--px-20) !important;
			li {
				margin-bottom: var(--px-10) !important;
			}
		}
		table {
			table-layout: fixed;
			width: 100%;
			white-space: pre-wrap;
			margin-bottom: var(--px-10);
			tr {
				display: table-row;
				vertical-align: inherit;
			}
			td,
			th {
				min-width: var(--px-10);
				border: var(--px-1) solid var(--neutrals-300);
				padding: var(--px-3) var(--px-5);
				vertical-align: top;
			}
			p {
				white-space: unset;
			}
		}
	}
	.editIcon {
		font-size: var(--px-14);
		font-weight: 700;
		position: absolute;
		bottom: var(--px-16);
		right: var(--px-30);
		color: var(--blue-600);
		display: flex;
		align-items: center;
		svg {
			margin-right: var(--px-3);
			fill: var(--blue-600);
			cursor: pointer;
			path {
				fill: var(--blue-600);
			}
		}
		.LabelText {
			cursor: pointer;
			font-size: var(--px-14);
			font-weight: 700;
			color: var(--blue-600);
		}
	}
`;
